import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=96ced9da&scoped=true&name=Notice&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "./Notice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Notice.vue?vue&type=style&index=1&id=96ced9da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ced9da",
  null
  
)

export default component.exports